import { render, staticRenderFns } from "./DataViewSidebar.vue?vue&type=template&id=932385d8&scoped=true&"
import script from "./DataViewSidebar.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebar.vue?vue&type=style&index=0&id=932385d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932385d8",
  null
  
)

export default component.exports